import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { DisputeCaseType } from "../../models/dispute-resolution/dispute-base-models";
import {
  CreateLinkedCasesRequestDto,
  LinkedCaseDto,
  LinkedCaseRefDto,
  SearchFiltersDto,
  SearchLinkedCasesRequestDto,
} from "../../models/dispute-resolution/linked-case-models";

@Injectable({
  providedIn: "root",
})
export class LinkedCasesService {
  private readonly baseUrl = "/api/dispute-resolution/linked-cases";

  constructor(private http: HttpClient) {}

  getLinkedCases(
    caseType: DisputeCaseType,
    caseId: string
  ): Observable<LinkedCaseDto[]> {
    const typeName = DisputeCaseType[caseType];
    return this.http.get<LinkedCaseDto[]>(
      `${this.baseUrl}/${typeName}/${caseId}`
    );
  }

  search(
    parentCaseType: DisputeCaseType,
    parentCaseId: string,
    filters: SearchFiltersDto
  ): Observable<LinkedCaseDto[]> {
    const body: SearchLinkedCasesRequestDto = {
      parentCaseType,
      parentCaseId,
      filters,
    };
    return this.http.post<LinkedCaseDto[]>(`${this.baseUrl}/search`, body);
  }

  createLinks(
    parentCaseType: DisputeCaseType,
    parentCaseId: string,
    linkedCases: LinkedCaseRefDto[]
  ): Observable<void> {
    const body: CreateLinkedCasesRequestDto = {
      parentCaseType,
      parentCaseId,
      linkedCases,
    };
    return this.http.post<void>(this.baseUrl, body);
  }

  deleteLink(
    parentCaseType: DisputeCaseType,
    parentCaseId: string,
    linkedCaseType: DisputeCaseType,
    linkedCaseId: string
  ): Observable<void> {
    const parentTypeName = DisputeCaseType[parentCaseType];
    const linkedTypeName = DisputeCaseType[linkedCaseType];
    return this.http.delete<void>(
      `${this.baseUrl}/${parentTypeName}/${parentCaseId}/${linkedTypeName}/${linkedCaseId}`
    );
  }
}
